<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
import LandingContent from '@/components/landing/LandingContent.vue';
import LandingFeatures from '@/components/landing/LandingFeatures.vue';
import LandingFooter from '@/components/landing/LandingFooter.vue';
import LandingHero from '@/components/landing/LandingHero.vue';
import LandingInfo from '@/components/landing/LandingInfo.vue';
import LandingPlans from '@/components/landing/LandingPlans.vue';

withDefaults(
    defineProps<{
        canRegister: boolean;
        content: Record<string, string | null>;
    }>(),
    {
        canRegister: true,
    },
);
</script>

<template>
    <Head title="Rate Your Hearing | Resonate" />

    <div class="min-h-screen">
        <main>
            <LandingHero :content="content" />
            <LandingFeatures :content="content" />
            <LandingContent :content="content" />
            <LandingInfo :content="content" />
            <LandingPlans :content="content" />
        </main>
        <LandingFooter :content="content" />
    </div>
</template>
